<script>
  import { Logo } from "./widget";
  import { load } from "../version.js";
  import { HStack, DStack, Spacer } from "./layout";

  export let year = "2021";
  export let company;
</script>

<footer>
  <DStack query="(min-width: 481px)" grow alignment="stretch">
    <HStack alignment="center">
      <Logo />
      <span>©{year} {company}. Tout droits réservés</span>
    </HStack>
    <Spacer />
    <HStack alignment="center">
      <Spacer />
      {#await load() then r}
        <span class="version">{r.data.v} (build {r.data.t})</span>
      {/await}
    </HStack>
  </DStack>
</footer>

<style>
  footer {
    display: flex;
    font-size: 0.75em;
    color: #797979;
    background-color: #f2f2f2;
  }

  @media screen and (max-width: 480px) {
    footer {
      font-size: 0.6em;
    }
  }
</style>
